import { ChangeEvent } from "react";

export default function createInputHandlers<TForm>(
  form: TForm,
  setForm: (form: TForm) => void,
): { handleChange: typeof handleChange; handleCheck: typeof handleCheck } {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { name, value },
    } = event;

    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleCheck = (event: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { name, checked },
    } = event;

    setForm({
      ...form,
      [name]: checked,
    });
  };

  return {
    handleChange,
    handleCheck,
  };
}
